<!--  -->
<template>
  <div id="stepSpan">
    <el-steps :active="currStep" align-center>
      <el-step title="选择套餐并提交" description=""></el-step>
      <el-step title="选择支付方式" description=""></el-step>
      <el-step title="在线支付" description=""></el-step>
      <el-step title="完成" description=""></el-step>
    </el-steps>
  </div>
</template>

<script>
export default {
  props: {
    currStep: Number
  },
  data () {
    return {}
  }
}
</script>
<style scoped>
#stepSpan {
  padding-top: 20px;
}

#stepSpan :deep(.el-step__title.is-process) {
  font-weight: 700;
  color: #f15c12;
}
</style>
